import './resolve';
import Vue from 'vue';
import './index.scss';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import {
  VUE_APP_PRODUCT_TABS,
  VUE_APP_PRODUCT_GALLERY
} from './main';

if (document.getElementById(VUE_APP_PRODUCT_TABS.ID)) {
  VUE_APP_PRODUCT_TABS.APP().then(module => {
    window.VUE_APP_PRODUCT_TABS = new Vue({
      el: `#${VUE_APP_PRODUCT_TABS.ID}`,
      render: h => h(module.default)
    });
  });
}

if (document.getElementById(VUE_APP_PRODUCT_GALLERY.ID)) {
  VUE_APP_PRODUCT_GALLERY.APP().then(module => {
    window.VUE_APP_PRODUCT_GALLERY = new Vue({
      el: `#${VUE_APP_PRODUCT_GALLERY.ID}`,
      render: h => h(module.default)
    });
  });
};